<div class="container">
  <section class="hero mb-lg">
    <span class="hero-eyebrow">Built for Indian money decisions</span>
    <h1>Know the Real Cost Before You Commit</h1>
    <p>
      A single decision — the tenure you pick, a prepayment you skip, a SIP you delay by a year —
      can be worth lakhs over time. These calculators turn that decision into hard numbers, so
      every rupee you borrow, invest or withdraw is a choice you made on purpose.
    </p>
    <div class="hero-actions">
      <a class="btn" [class.btn-primary]="activeHeroSection() === 'calculators'"
        [class.btn-secondary]="activeHeroSection() !== 'calculators'" href="#calculators">Explore calculators</a>
      <a class="btn" [class.btn-primary]="activeHeroSection() === 'services'"
        [class.btn-secondary]="activeHeroSection() !== 'services'" href="#services">Services</a>
      <a class="btn btn-secondary" routerLink="/learn">Read the guides</a>
    </div>
    <ul class="hero-trust-bar">
      <li>20+ calculators</li>
      <li>Built for India</li>
    </ul>
  </section>

  <section class="insights-section mb-lg">
    @for (i of insights; track i.title) {
      <div class="insight-callout">
        <div class="insight-callout-icon"><app-icon [name]="i.icon"/></div>
        <div class="insight-callout-body">
          <h2>{{ i.title }}</h2>
          <p>{{ i.body }}</p>
        </div>
      </div>
    }
  </section>

  <div id="calculators"></div>
  @for (g of groups; track g.label) {
    <section class="calc-group mb-lg">
      <div class="calc-group-header">
        <h2>{{ g.label }}</h2>
        <p>{{ g.hint }}</p>
      </div>
      <div class="calc-grid">
        @for (c of g.calculators; track c.route) {
          <a class="calc-card" [routerLink]="c.route">
            <div class="calc-card-icon"><app-icon [name]="c.icon"/></div>
            <div class="calc-card-title">{{ c.title }}</div>
            <p class="calc-card-desc">{{ c.description }}</p>
            <span class="calc-card-cta">Open calculator →</span>
          </a>
        }
      </div>
    </section>
  }

  <section class="calc-group mb-lg" id="services">
    <div class="calc-group-header">
      <h2>Services</h2>
      <p>Beyond the calculators — premium tools for everyone, from individuals to large businesses.</p>
    </div>
    <div class="calc-grid">
      <a class="calc-card" routerLink="/reminders">
        <div class="calc-card-icon"><app-icon name="notifications"/></div>
        <div class="calc-card-title">Reminders</div>
        <p class="calc-card-desc">A missed credit-card bill, an insurance premium that lapses, a late EMI — each one quietly costs you late fees, penalty interest and a dented credit score. Get timely reminders before every due date and never lose money to a forgotten payment again.</p>
        <span class="calc-card-cta">Set up reminders →</span>
      </a>
      <a class="calc-card" routerLink="/budget">
        <div class="calc-card-icon"><app-icon name="account_balance_wallet"/></div>
        <div class="calc-card-title">Budget & Expense Tracker</div>
        <p class="calc-card-desc">Set a monthly budget — overall or per category — log every expense as you spend, and see exactly where you stand at a glance. Free forever for basic tracking. ₹499/year unlocks per-category budgets and full history.</p>
        <span class="calc-card-cta">Start tracking →</span>
      </a>
      <a class="calc-card" routerLink="/todo">
        <div class="calc-card-icon"><app-icon name="assignment"/></div>
        <div class="calc-card-title">To-Do</div>
        <p class="calc-card-desc">A simple to-do list for everything that isn't a bill or a reminder. Free covers up to 5 to-dos. ₹500/year unlocks up to 100.</p>
        <span class="calc-card-cta">Start your list →</span>
      </a>
      @if (rmsEnabled) {
        <a class="calc-card" routerLink="/rms">
          <div class="calc-card-icon"><app-icon name="home_work"/></div>
          <div class="calc-card-title">Rental Management System</div>
          <p class="calc-card-desc">Properties, tenants, leases, rent collection, maintenance and rental agreements — everything a landlord needs in one place, plus a self-serve portal for tenants. Free for your first property. Paid tiers from ₹599/year add maintenance tracking, tenant self-service and more.</p>
          <span class="calc-card-cta">Manage your properties →</span>
        </a>
      }
      @if (rentalAgreementEnabled) {
        <a class="calc-card" routerLink="/rental-agreement">
          <div class="calc-card-icon"><app-icon name="description"/></div>
          <div class="calc-card-title">Rental Agreement Generator</div>
          <p class="calc-card-desc">A legally drafted, e-Stamped and e-signed 11-month rental agreement for Karnataka — no RMS account needed. ₹300 flat for the draft, plus stamp duty and e-stamp/e-sign handling.</p>
          <span class="calc-card-cta">Generate an agreement →</span>
        </a>
      }
    </div>
  </section>

  @if (testimonials().length > 0) {
    <section class="calc-group mb-lg">
      <div class="calc-group-header">
        <h2>What our users say</h2>
        <p>Real feedback from people using our calculators and services.</p>
      </div>
      <div class="home-testimonial-grid">
        @for (t of testimonials(); track t.id) {
          <div class="home-testimonial-card">
            <div class="home-testimonial-stars" aria-hidden="true">
              @for (star of stars; track star) {
                <span class="home-star" [class.filled]="star <= t.rating">★</span>
              }
            </div>
            <p class="home-testimonial-message">"{{ t.message }}"</p>
            <div class="home-testimonial-author">
              <span class="home-testimonial-name">{{ t.name }}</span>
              @if (t.role) {
                <span class="home-testimonial-role">{{ t.role }}</span>
              }
            </div>
          </div>
        }
      </div>
      <a class="home-testimonial-link" routerLink="/testimonials">Read all reviews / share your experience →</a>
    </section>
  }
</div>
